import { Box, Button, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { getErrorMessage, wsmSsoMessages } from "../components/LoginPage/messages";
import { UserContextError } from "../types";

interface WsmSignInProps {
  errors: UserContextError[];
  /** What the API said when it refused the last sign-in, in its own words, if it did. */
  message?: string | null;
  disabled?: boolean;
  onSignIn: () => void;
}

/**
 * The sign-in route on a Web Shop Manager tenant when it is not redirecting: after a
 * deliberate sign-out, or after Clerk or the API refused the last attempt. No password
 * form and no provider list; one button, which starts the same redirect the route
 * starts on its own, and the reason it stopped, if there is one. Clerk's screens do the
 * signing in; this is only the doorstep.
 */
const WsmSignIn = ({ errors, message = null, disabled = false, onSignIn }: WsmSignInProps) => {
  const intl = useIntl();
  const reason = message || (errors.length ? getErrorMessage(errors[0], intl) : "");

  return (
    <Box display="flex" flexDirection="column" gap={6} data-test-id="wsm-sign-in">
      {reason && (
        <Text color="critical2" data-test-id="wsm-sign-in-message">
          {reason}
        </Text>
      )}
      <Button
        variant="primary"
        width="100%"
        disabled={disabled}
        onClick={onSignIn}
        data-test-id="wsm-sign-in-button"
      >
        <FormattedMessage {...wsmSsoMessages.signIn} />
      </Button>
    </Box>
  );
};

WsmSignIn.displayName = "WsmSignIn";
export default WsmSignIn;
